import { UploadSummaryComponent } from './file-upload-summary.component';
import { uploadSummaryFields } from './file-upload-summary.constants';
import 'angular-svg-round-progressbar';

export default angular
  .module('ng1-file-upload-summary', ['angular-svg-round-progressbar'])
  .constant('uploadSummaryFields', uploadSummaryFields)
  .component('uploadSummary', UploadSummaryComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-file-upload/src/summary/file-upload-summary.js